import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgValuecode = function SvgValuecode(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 24 24",
    size: size
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M19.93 2.531h-2.016c0 .844-.656 1.5-1.5 1.5a1.48 1.48 0 01-1.5-1.5H4.024A3.981 3.981 0 00.038 6.516v10.968a3.981 3.981 0 003.984 3.985h10.938c0-.844.656-1.5 1.5-1.5s1.5.656 1.5 1.5h2.016a3.981 3.981 0 003.984-3.985V6.516c0-2.204-1.828-3.985-4.031-3.985zm-8.235 10.172l-3 2.953a1.033 1.033 0 01-.703.281c-.234 0-.515-.093-.703-.28a1.02 1.02 0 010-1.407l1.266-1.266H4.992A.99.99 0 014.008 12c0-.516.469-.984.984-.984h3.563L7.289 9.703a1.02 1.02 0 010-1.406 1.02 1.02 0 011.406 0l3 3c.375.375.375.984 0 1.406zm4.766 5.25a1.48 1.48 0 01-1.5-1.5c0-.844.656-1.5 1.5-1.5s1.5.656 1.5 1.5-.656 1.5-1.5 1.5zm0-4.5a1.48 1.48 0 01-1.5-1.5c0-.844.656-1.5 1.5-1.5s1.5.656 1.5 1.5-.656 1.5-1.5 1.5zm0-4.453a1.48 1.48 0 01-1.5-1.5c0-.844.656-1.5 1.5-1.5s1.5.656 1.5 1.5-.656 1.5-1.5 1.5z"
  }));
};

export default SvgValuecode;